import { BrainCircuit, Hammer, MessageSquare, Sparkles } from "lucide-react";
import * as React from "react";

import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";

import { useAiPanelStore, type AiPanelBridge, type AiPanelMode } from "./ai-panel-store";
import { ChatMode } from "./chat-mode";
import { CraftMode } from "./craft-mode";
import { DesignMode } from "./design-mode";
import { PlanMode } from "./plan-mode";

const MODES: { value: AiPanelMode; label: string; icon: React.ElementType }[] = [
  { value: "plan", label: "Plan", icon: BrainCircuit },
  { value: "design", label: "Design", icon: Sparkles },
  { value: "craft", label: "Craft", icon: Hammer },
  { value: "chat", label: "Chat", icon: MessageSquare },
];

/**
 * 四模式 AI 面板（ARCHITECTURE_DESIGN.md §5.3）：
 * 模式切换条 + 内容区 + 输入框。挂在 builder 右侧「属性 | AI」tab 下。
 */
export function AiPanel(props: AiPanelBridge) {
  const mode = useAiPanelStore((state) => state.mode);
  const setMode = useAiPanelStore((state) => state.setMode);

  return (
    <Tabs value={mode} onValueChange={(value) => setMode(value as AiPanelMode)} className="flex h-full flex-col">
      <TabsList className="mx-3 mt-1 grid w-auto grid-cols-4 gap-1">
        {MODES.map((item) => (
          <TabsTrigger
            key={item.value}
            value={item.value}
            data-testid={`ai-mode-${item.value}`}
            className="flex items-center gap-1 px-2 py-1 text-xs"
          >
            <item.icon className="h-3.5 w-3.5" />
            {item.label}
          </TabsTrigger>
        ))}
      </TabsList>
      <TabsContent value="plan" className="mt-1 min-h-0 flex-1 overflow-hidden data-[state=inactive]:hidden">
        <PlanMode {...props} />
      </TabsContent>
      <TabsContent value="design" className="mt-1 min-h-0 flex-1 overflow-hidden data-[state=inactive]:hidden">
        <DesignMode {...props} />
      </TabsContent>
      <TabsContent value="craft" className="mt-1 min-h-0 flex-1 overflow-hidden data-[state=inactive]:hidden">
        <CraftMode {...props} />
      </TabsContent>
      <TabsContent value="chat" className="mt-1 min-h-0 flex-1 overflow-hidden data-[state=inactive]:hidden">
        <ChatMode {...props} />
      </TabsContent>
    </Tabs>
  );
}
